export const environment = {
  production: false,
  name: 'qa',
  projectName: 'RUBi',
  defaultTheme: 'RUBi',
  version: '1.1.2',
  region: 'us-gov-west-1',
  url: 'https://rubi-qa.cristlgov.com',
  endpoint: 'https://rubi-be-qa.cristlgov.com',
  sandboxEnabled: false,
  uamUrl: 'https://qa.cristlgov.com/',
  refreshEndpoint: 'https://qa-be.cristlgov.com/auth/refreshToken',
  boardsEnabled: true,
  cookieInfo: {
    domain: '.cristlgov.com',
  }
};
